import * as yup from 'yup';

export const createFolderSchema = yup.object({
  name: yup
    .string()
    .required('Folder Name is required')
    .max(100, '100 characters max')
    .matches(/^[a-zA-Z0-9.\s\-:_]*$/, 'Cannot use special characters'),
});

export const editFolderSchema = yup.object({
  name: yup
    .string()
    .required('Folder Name is required')
    .max(100, '100 characters max')
    .matches(/^[a-zA-Z0-9.\s\-:_]*$/, 'Cannot use special characters'),
});

export const editFileSchema = yup.object({
  name: yup
    .string()
    .required('File Name is required')
    .max(100, '100 characters max')
    .matches(/^[a-zA-Z0-9.\s\-:_]*$/, 'Cannot use special characters'),
});
